import { FeeSchedule, FeeScheduleControllerApi } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 * @author Rajkumar Rathod
 */
export const useUpdateFeeSchedule = () =>
  useMutationWithLoading(
    async (params: { feeSchedule: FeeSchedule; xTENANTID?: string }) =>
      new FeeScheduleControllerApi(getConfigObject()).updateFeeSchedule(
        params.feeSchedule,
        params.xTENANTID
      )
  );
